<template>
	<span v-if="localApplicant">
		<Messages
			:job-profile-list-item="jobProfileListItem"
			:applicant="localApplicant"
			@close="fireChange"
		/>
		<Calendar
			:job-profile-list-item="jobProfileListItem"
			:applicant="localApplicant"
			@closeAppointments="fireChange"
		/>
		<Favorite
			v-if="permissions.favoriteJobProfile"
			:job-profile-id="jobProfile.id"
			:job-id="jobId"
			:applicant="localApplicant"
			:initial-favored="localApplicant.favored"
			type="customer"
			@change="fireChange"
		/>
		<Notice
			v-if="permissions.notice"
			:job-profile-id="jobProfile.id"
			:applicant="localApplicant"
			:notice="localApplicant.notice"
			type="customer"
			:sub-title="applicantName"
			@change="fireChange"
		/>
		<Exclusion
			v-if="permissions.excludeJobProfile || permissions.excludeComprehensive"
			:job-profile-id="jobProfile.id"
			:job-id="jobId"
			:applicant="localApplicant"
			:permission-job-profile="permissions.excludeJobProfile"
			:permission-comprehensive="permissions.excludeComprehensive"
			:initial-exclusion-type="initialExclusionType"
			@exclude="fireChange"
			@remove="fireChange"
		/>
	</span>
</template>

<script>
import Favorite from "@/vue/customer/job-profile/applicant/Favorite.vue";
import Exclusion from "@/vue/customer/job-profile/applicant/Exclusion.vue";
import Messages from "@/vue/customer/job-profile/applicant/Messages.vue";
import Notice from "@/vue/job-result/notice/Notice.vue";
import Calendar from "@/vue/customer/job-profile/applicant/Calendar";
import {get} from "@/helper/job-profile/applicant/Name";
import GetList from "@/api/customer/job-profile/applicant/GetList";
import _ from "lodash";
import EventBus from "@/event/EventBus";
import {JOB_PROFILE_APPLICANT_LIST_ITEM_ACTION} from "@/event/Event";
import {mapMutations} from "vuex";

export default {
	components: {Notice, Messages, Exclusion, Calendar, Favorite},

	props: {
		jobProfileListItem: {
			type: Object,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
		applicant: {
			type: Object,
			required: true,
		},
		permissions: {
			type: Object,
			required: true,
		},
		initialExclusionType: {
			type: String,
			required: false
		}
	},

	mounted ()
	{
		this.eventHandler = async ({jobProfile, applicant}) =>
		{
			if (
				this.jobProfile.id === jobProfile.id
				&& this.localApplicant?.id === applicant.id
			)
			{
				// logic with this as some components are firing too much events, which would lead to a lot of requests
				if (this.handlingEvent)
				{
					return;
				}

				this.handlingEvent = true;

				await this.reloadApplicant();

				this.handlingEvent = false;
			}
		};

		EventBus.$on(JOB_PROFILE_APPLICANT_LIST_ITEM_ACTION, this.eventHandler);
	},

	beforeDestroy ()
	{
		EventBus.$off(JOB_PROFILE_APPLICANT_LIST_ITEM_ACTION, this.eventHandler);
	},

	data ()
	{
		return {
			eventHandler: undefined,
			handlingEvent: false,
			localApplicant: this.applicant,
		};
	},

	computed: {
		applicantName ()
		{
			return this.localApplicant ? get(this.localApplicant) : '';
		},
		jobProfile ()
		{
			return this.jobProfileListItem.jobProfile;
		},
	},

	methods: {
		...mapMutations('job/vita', [
			'setExclusionType'
		]),
		fireChange ()
		{
			const eventData = {
				jobProfile: this.jobProfile,
				applicant: this.localApplicant,
			}

			EventBus.$emit(JOB_PROFILE_APPLICANT_LIST_ITEM_ACTION, eventData);
		},
		async reloadApplicant ()
		{
			const response = await new GetList()
				.setJobProfileId(this.jobProfileListItem.jobProfile.id)
				.setJobId(this.jobId)
				.setOffset(0)
				.setLimit(1)
				.call();

			const applicants = response.data.applicants;

			// it could be that no applicant came back after loading as he was excluded / sent off
			if (applicants.length > 0)
			{
				const applicant = _.first(applicants);

				this.$emit('applicantChanged', applicant);

				// force actions remount
				this.localApplicant = undefined;

				// exclusion type in fan can only be undefined if applicant got returned by this call
				this.setExclusionType(undefined);

				this.$nextTick(() => this.localApplicant = applicant);
			}
		}
	}
}
</script>
